/* cb-article.js - inhoudsopgave en "kopieer link" op de gidsenpagina
 *
 * Hoort bij sections/cb-article.liquid. De inhoudsopgave staat niet in de
 * artikeltekst maar wordt hier geteld: elke H2 in de rte krijgt een id en komt
 * in de lijst. Zo klopt hij ook nadat de redactie een kop toevoegt. Staan er
 * geen H2's, dan blijft de kaart op `hidden` staan en zie je er niets van.
 */
(function () {
  var root = document.querySelector('[data-cb-article]');
  if (!root) { return; }

  var rte = root.querySelector('[data-cb-rte]');
  var inline = root.querySelector('[data-cb-toc]');
  var aside = root.querySelector('[data-cb-toc-aside]');

  if (rte) {
    var headings = Array.prototype.slice.call(rte.querySelectorAll('h2'));

    if (headings.length > 0) {
      var items = headings.map(function (heading, index) {
        if (!heading.id) { heading.id = 'cb-s' + (index + 1); }
        return { id: heading.id, text: heading.textContent.trim() };
      });

      Array.prototype.forEach.call(root.querySelectorAll('[data-cb-toc-list]'), function (list) {
        items.forEach(function (item) {
          var li = document.createElement('li');
          var link = document.createElement('a');
          link.href = '#' + item.id;
          link.textContent = item.text;
          li.appendChild(link);
          list.appendChild(li);
        });
      });

      var count = root.querySelector('[data-cb-toc-count]');
      if (count) {
        var word = items.length === 1
          ? root.getAttribute('data-toc-one')
          : root.getAttribute('data-toc-many');
        count.textContent = '· ' + items.length + ' ' + word;
      }

      if (inline) { inline.hidden = false; }
      if (aside) { aside.hidden = false; }
    }
  }

  /* Alleen de inline-versie klapt open en dicht. Vanaf 1000px staat hij in de
     zijbalk en is hij altijd open; die heeft dus geen knop. */
  var toggle = root.querySelector('[data-cb-toc-toggle]');
  if (toggle && inline) {
    var list = inline.querySelector('[data-cb-toc-list]');
    toggle.addEventListener('click', function () {
      var open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
      if (list) { list.hidden = open; }
    });
  }

  var copy = root.querySelector('[data-cb-copy]');
  if (copy && navigator.clipboard) {
    copy.addEventListener('click', function () {
      navigator.clipboard.writeText(copy.getAttribute('data-url')).then(function () {
        copy.textContent = root.getAttribute('data-copied-label');
        copy.classList.add('is-done');
        setTimeout(function () {
          copy.textContent = root.getAttribute('data-copy-label');
          copy.classList.remove('is-done');
        }, 1600);
      });
    });
  } else if (copy) {
    /* Zonder clipboard-API doet de knop niets, dus staat hij er ook niet. */
    copy.hidden = true;
  }
})();
